import BackMethods from "../../back_component/BackMethods";
export default function HomePage() {
    const user = localStorage.getItem("user");
    console.log(user);
    return (
        <div>

            <div className="row justify-content-center bg-dark pt-5 mt-5">


                <h1>Home page</h1>
            </div>


        </div>

    );
}
